/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminDatasetsRouteImport } from './routes/_app/admin/datasets'
import { Route as AppAdminRolesRouteImport } from './routes/_app/admin/roles'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppCrmIndexRouteImport } from './routes/_app/crm/index'
import { Route as AppCrmMappingRouteImport } from './routes/_app/crm/mapping'
import { Route as AppDashboardsIndexRouteImport } from './routes/_app/dashboards/index'
import { Route as AppLeadsIndexRouteImport } from './routes/_app/leads/index'
import { Route as AppLeadsLeadIdRouteImport } from './routes/_app/leads/$leadId'
import { Route as AppLinkedinIndexRouteImport } from './routes/_app/linkedin/index'
import { Route as AppLinkedinCampaignsRouteImport } from './routes/_app/linkedin/campaigns'
import { Route as AppDashboardsDashboardIdIndexRouteImport } from './routes/_app/dashboards/$dashboardId/index'
import { Route as AppDashboardsDashboardIdEditRouteImport } from './routes/_app/dashboards/$dashboardId/edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminDatasetsRoute = AppAdminDatasetsRouteImport.update({
  id: '/admin/datasets',
  path: '/admin/datasets',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmIndexRoute = AppCrmIndexRouteImport.update({
  id: '/crm/',
  path: '/crm/',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmMappingRoute = AppCrmMappingRouteImport.update({
  id: '/crm/mapping',
  path: '/crm/mapping',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsIndexRoute = AppDashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsIndexRoute = AppLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsLeadIdRoute = AppLeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => AppRoute,
} as any)
const AppLinkedinIndexRoute = AppLinkedinIndexRouteImport.update({
  id: '/linkedin/',
  path: '/linkedin/',
  getParentRoute: () => AppRoute,
} as any)
const AppLinkedinCampaignsRoute = AppLinkedinCampaignsRouteImport.update({
  id: '/linkedin/campaigns',
  path: '/linkedin/campaigns',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsDashboardIdIndexRoute =
  AppDashboardsDashboardIdIndexRouteImport.update({
    id: '/dashboards/$dashboardId/',
    path: '/dashboards/$dashboardId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDashboardsDashboardIdEditRoute =
  AppDashboardsDashboardIdEditRouteImport.update({
    id: '/dashboards/$dashboardId/edit',
    path: '/dashboards/$dashboardId/edit',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account': typeof AppAccountRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/datasets': typeof AppAdminDatasetsRoute
  '/admin/roles': typeof AppAdminRolesRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/crm/mapping': typeof AppCrmMappingRoute
  '/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/linkedin/campaigns': typeof AppLinkedinCampaignsRoute
  '/crm/': typeof AppCrmIndexRoute
  '/dashboards/': typeof AppDashboardsIndexRoute
  '/leads/': typeof AppLeadsIndexRoute
  '/linkedin/': typeof AppLinkedinIndexRoute
  '/dashboards/$dashboardId/edit': typeof AppDashboardsDashboardIdEditRoute
  '/dashboards/$dashboardId/': typeof AppDashboardsDashboardIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account': typeof AppAccountRoute
  '/': typeof AppIndexRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/datasets': typeof AppAdminDatasetsRoute
  '/admin/roles': typeof AppAdminRolesRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/crm/mapping': typeof AppCrmMappingRoute
  '/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/linkedin/campaigns': typeof AppLinkedinCampaignsRoute
  '/crm': typeof AppCrmIndexRoute
  '/dashboards': typeof AppDashboardsIndexRoute
  '/leads': typeof AppLeadsIndexRoute
  '/linkedin': typeof AppLinkedinIndexRoute
  '/dashboards/$dashboardId/edit': typeof AppDashboardsDashboardIdEditRoute
  '/dashboards/$dashboardId': typeof AppDashboardsDashboardIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/datasets': typeof AppAdminDatasetsRoute
  '/_app/admin/roles': typeof AppAdminRolesRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/crm/mapping': typeof AppCrmMappingRoute
  '/_app/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/_app/linkedin/campaigns': typeof AppLinkedinCampaignsRoute
  '/_app/crm/': typeof AppCrmIndexRoute
  '/_app/dashboards/': typeof AppDashboardsIndexRoute
  '/_app/leads/': typeof AppLeadsIndexRoute
  '/_app/linkedin/': typeof AppLinkedinIndexRoute
  '/_app/dashboards/$dashboardId/edit': typeof AppDashboardsDashboardIdEditRoute
  '/_app/dashboards/$dashboardId/': typeof AppDashboardsDashboardIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/account'
    | '/admin/audit'
    | '/admin/datasets'
    | '/admin/roles'
    | '/admin/users'
    | '/crm/mapping'
    | '/leads/$leadId'
    | '/linkedin/campaigns'
    | '/crm/'
    | '/dashboards/'
    | '/leads/'
    | '/linkedin/'
    | '/dashboards/$dashboardId/edit'
    | '/dashboards/$dashboardId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/account'
    | '/'
    | '/admin/audit'
    | '/admin/datasets'
    | '/admin/roles'
    | '/admin/users'
    | '/crm/mapping'
    | '/leads/$leadId'
    | '/linkedin/campaigns'
    | '/crm'
    | '/dashboards'
    | '/leads'
    | '/linkedin'
    | '/dashboards/$dashboardId/edit'
    | '/dashboards/$dashboardId'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/_app/account'
    | '/_app/'
    | '/_app/admin/audit'
    | '/_app/admin/datasets'
    | '/_app/admin/roles'
    | '/_app/admin/users'
    | '/_app/crm/mapping'
    | '/_app/leads/$leadId'
    | '/_app/linkedin/campaigns'
    | '/_app/crm/'
    | '/_app/dashboards/'
    | '/_app/leads/'
    | '/_app/linkedin/'
    | '/_app/dashboards/$dashboardId/edit'
    | '/_app/dashboards/$dashboardId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/datasets': {
      id: '/_app/admin/datasets'
      path: '/admin/datasets'
      fullPath: '/admin/datasets'
      preLoaderRoute: typeof AppAdminDatasetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/roles': {
      id: '/_app/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AppAdminRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crm/': {
      id: '/_app/crm/'
      path: '/crm'
      fullPath: '/crm/'
      preLoaderRoute: typeof AppCrmIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crm/mapping': {
      id: '/_app/crm/mapping'
      path: '/crm/mapping'
      fullPath: '/crm/mapping'
      preLoaderRoute: typeof AppCrmMappingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/': {
      id: '/_app/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof AppDashboardsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/': {
      id: '/_app/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AppLeadsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId': {
      id: '/_app/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof AppLeadsLeadIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/linkedin/': {
      id: '/_app/linkedin/'
      path: '/linkedin'
      fullPath: '/linkedin/'
      preLoaderRoute: typeof AppLinkedinIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/linkedin/campaigns': {
      id: '/_app/linkedin/campaigns'
      path: '/linkedin/campaigns'
      fullPath: '/linkedin/campaigns'
      preLoaderRoute: typeof AppLinkedinCampaignsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/$dashboardId/': {
      id: '/_app/dashboards/$dashboardId/'
      path: '/dashboards/$dashboardId'
      fullPath: '/dashboards/$dashboardId/'
      preLoaderRoute: typeof AppDashboardsDashboardIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/$dashboardId/edit': {
      id: '/_app/dashboards/$dashboardId/edit'
      path: '/dashboards/$dashboardId/edit'
      fullPath: '/dashboards/$dashboardId/edit'
      preLoaderRoute: typeof AppDashboardsDashboardIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminDatasetsRoute: typeof AppAdminDatasetsRoute
  AppAdminRolesRoute: typeof AppAdminRolesRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppCrmMappingRoute: typeof AppCrmMappingRoute
  AppLeadsLeadIdRoute: typeof AppLeadsLeadIdRoute
  AppLinkedinCampaignsRoute: typeof AppLinkedinCampaignsRoute
  AppCrmIndexRoute: typeof AppCrmIndexRoute
  AppDashboardsIndexRoute: typeof AppDashboardsIndexRoute
  AppLeadsIndexRoute: typeof AppLeadsIndexRoute
  AppLinkedinIndexRoute: typeof AppLinkedinIndexRoute
  AppDashboardsDashboardIdEditRoute: typeof AppDashboardsDashboardIdEditRoute
  AppDashboardsDashboardIdIndexRoute: typeof AppDashboardsDashboardIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminDatasetsRoute: AppAdminDatasetsRoute,
  AppAdminRolesRoute: AppAdminRolesRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppCrmMappingRoute: AppCrmMappingRoute,
  AppLeadsLeadIdRoute: AppLeadsLeadIdRoute,
  AppLinkedinCampaignsRoute: AppLinkedinCampaignsRoute,
  AppCrmIndexRoute: AppCrmIndexRoute,
  AppDashboardsIndexRoute: AppDashboardsIndexRoute,
  AppLeadsIndexRoute: AppLeadsIndexRoute,
  AppLinkedinIndexRoute: AppLinkedinIndexRoute,
  AppDashboardsDashboardIdEditRoute: AppDashboardsDashboardIdEditRoute,
  AppDashboardsDashboardIdIndexRoute: AppDashboardsDashboardIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
